import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';

import './UpSelfOnboarding.less';

const steps = [
  {
    id: 'user',
    title: 'User',
  },
  {
    id: 'brand',
    title: 'Brand',
  },
  {
    id: 'sync',
    title: 'Sync',
  },
  {
    id: 'inviteTeam',
    title: 'Team',
  },
  {
    id: 'connect',
    title: 'Connect',
  },
  {
    id: 'email',
    title: 'Email',
  },
  {
    id: 'intro',
    title: 'Intro',
  },
];

const UpSelfOnboardingHeader = ({
  activeIndex,
  partnerGroupLogoUrl,
  partnerGroupPrimaryColor,
  partnerGroupSecondaryColor,
  partnerGroupInactiveTextColor,
}) => {
  return (
    <div styleName="header">
      <div>
        {partnerGroupLogoUrl ? (
          <SrBox
            display="flex"
            justifyContent="space-between"
            alignItems="flex-start"
            marginRight="32px"
          >
            <SrBox
              height="60px"
              width="calc(50% - 8px)"
              backgroundImage={`url(${partnerGroupLogoUrl})`}
              backgroundSize="contain"
              backgroundRepeat="no-repeat"
              backgroundPosition="left"
            />
            <SrBox display="flex" flexDirection="column" width="calc(30% - 8px)">
              <SrText color="grey" fontSize="12px" weight="700" display="block" lineHeight="12px">
                Powered by
              </SrText>
              <SrBox
                marginTop="4px"
                height="20px"
                width="100%"
                backgroundImage="url(/images/utility-profit-logo.svg)"
                backgroundSize="contain"
                backgroundRepeat="no-repeat"
                backgroundPosition="left"
              />
            </SrBox>
          </SrBox>
        ) : (
          <SrBox
            height="30px"
            width="100%"
            backgroundImage="url(/images/utility-profit-logo.svg)"
            backgroundSize="contain"
            backgroundRepeat="no-repeat"
            backgroundPosition="left center"
          />
        )}
      </div>
      <div styleName="steps">
        {steps.map((step, index) => {
          return (
            <div
              key={step.id}
              styleName={classnames('step', {
                past: index < activeIndex,
                active: index === activeIndex,
              })}
            >
              <div
                styleName="line"
                style={{
                  ...(partnerGroupPrimaryColor && {
                    backgroundColor: partnerGroupPrimaryColor,
                  }),
                }}
              />
              <span
                style={{
                  ...(partnerGroupSecondaryColor && {
                    color:
                      index <= activeIndex
                        ? partnerGroupSecondaryColor
                        : partnerGroupInactiveTextColor,
                  }),
                }}
              >
                {step.title}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

UpSelfOnboardingHeader.propTypes = {
  activeIndex: PropTypes.number,
  partnerGroupLogoUrl: PropTypes.string,
  partnerGroupPrimaryColor: PropTypes.string,
  partnerGroupSecondaryColor: PropTypes.string,
  partnerGroupInactiveTextColor: PropTypes.string,
};

UpSelfOnboardingHeader.defaultProps = {
  activeIndex: 0,
};

UpSelfOnboardingHeader.displayName = 'UpSelfOnboardingHeader';

export default UpSelfOnboardingHeader;
